<template>
    <button class="primary-bg-color">
        zurück
    </button>
</template>

<script>
export default {
  methods: {
    // scrollTop() {
    //   window.scroll({
    //     top: 0,
    //     left: 0,
    //     behaviour: "smooth"
    //   });
    // }
  }
};
</script>

<style scoped lang="scss">
button {
  position: fixed;
  bottom: 120px;
  right: 20px;
  opacity: 0.5;
  margin: 10px;
  padding: 15px;
  border-radius: 10px;
  border: none;
  color: white;
  &:hover {
    opacity: 0.9;
  }
}
</style>

